import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const OrgSettingsContext = createContext({ currency: "AED", timezone: "Asia/Dubai", refresh: () => {} });

export function OrgSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ currency: "AED", timezone: "Asia/Dubai" });

  const refresh = useCallback(() => {
    Promise.all([
      api.get("/company-profile").catch(() => null),
      api.get("/admin-settings/dashboard-targets").catch(() => null),
    ]).then(([cp, dt]) => {
      const org = cp?.data?.data?.organization || {};
      const targets = dt?.data?.data || {};
      setSettings({
        currency: org.currency || targets.currency || "AED",
        timezone: org.timezone || "Asia/Dubai",
        tenantName: cp?.data?.data?.company_profile?.legal_name || org.name || "",
      });
    });
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <OrgSettingsContext.Provider value={{ ...settings, refresh }}>{children}</OrgSettingsContext.Provider>;
}

export function useOrgSettings() {
  return useContext(OrgSettingsContext);
}

// Formatting helpers — read currency/timezone from the provider OR accept overrides
export function fmtCurrency(amount, currency = "AED") {
  if (amount == null || isNaN(amount)) return "—";
  try {
    return new Intl.NumberFormat("en-AE", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount);
  } catch {
    return `${currency} ${Number(amount).toLocaleString()}`;
  }
}

export function fmtDateTime(iso, timezone = "Asia/Dubai") {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short", timeZone: timezone }).format(new Date(iso));
  } catch { return new Date(iso).toLocaleString(); }
}

export function fmtDate(iso, timezone = "Asia/Dubai") {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeZone: timezone }).format(new Date(iso));
  } catch { return new Date(iso).toLocaleDateString(); }
}
